import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router'

import { Flex, Text, TextButton } from '@enechain/ecloud-designsystem'

import type { AutomationSettingCounts } from '~/hooks/useAutomationSettingCounts'
import { routePaths } from '~/routes/routePaths'

/**
 * 自動化の設定を持つ画面への入口 (AC-AEH-010)。
 * 件数が取得できていない間は 0 件と出す (React mock と同じ)。
 */
export const AutomationSettingEntries = ({
  counts,
}: {
  counts: AutomationSettingCounts
}): React.ReactElement => {
  const { t } = useTranslation()
  const ready = counts.status === 'ready' ? counts : undefined
  const autoBidRuleCount = ready?.autoBidRuleCount ?? 0
  const planAutomatedSubStepCount = ready?.planAutomatedSubStepCount ?? 0
  return (
    <Flex
      alignItems="center"
      flexWrap="wrap"
      flexShrink={0}
      gap={4}
      padding={3}
      borderWidth="1px"
      borderColor="Border.lowEmphasis"
      borderRadius="lg"
    >
      <Text textStyle="filterLabel">
        {t('page:autoExecutionHistory.settings.title')}
      </Text>
      <TextButton asChild size="sm">
        <RouterLink to={routePaths.adminApprovalFlow.path}>
          {t('page:autoExecutionHistory.settings.autoBidRuleWithCount', {
            count: autoBidRuleCount,
          })}
        </RouterLink>
      </TextButton>
      <TextButton asChild size="sm">
        <RouterLink to={routePaths.adminWorkflowTemplates.path}>
          {t('page:autoExecutionHistory.settings.planAutomationWithCount', {
            count: planAutomatedSubStepCount,
          })}
        </RouterLink>
      </TextButton>
      <Text textStyle="caption" color="Text.midEmphasis">
        {t('page:autoExecutionHistory.settings.note')}
      </Text>
    </Flex>
  )
}
